import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _delay from 'lodash/delay';
import _toNumber from 'lodash/toNumber';
import PropTypes from 'prop-types';
// Models
import mUser from 'models/user';
// Custom
import {
  getUsersList, deleteUser, refreshList,
} from 'actions';
import { meDataShape, fullListShape } from 'constants/PropTypesShapes';
import { addPath, navigateToShow } from 'users/navigation';
import { AddTextButton } from 'components/buttons/TextButtons';
import MainListTemplate from 'components/templates/MainListTemplate';
import withConfirmDialog from 'hocs/WithConfirmDialog';
import withLoading from 'hocs/WithLoading';
import withPermissions from 'hocs/WithPermissions';
import withTitle from 'hocs/WithTitle';
import UserFilters from 'users/assets/main/UserFilters';
import UserRow from 'users/assets/main/UserRow';

class UsersList extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteUser = this.handleDeleteUser.bind(this);
    this.handleRowDbleClick = this.handleRowDbleClick.bind(this);
    this.doGetRowComp = this.doGetRowComp.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { deleted, handleRefreshList } = this.props;
    if (!prevProps.deleted && deleted) {
      handleRefreshList();
    }
  }

  // Handlers
  handleDeleteUser(user) {
    const { handleDisplayConfirm, handleDeleteUser } = this.props;
    handleDisplayConfirm(
      { id: 'confirm.deleteUser', values: { userName: mUser.fullName(user) } },
      () => handleDeleteUser(user.id),
    );
  }

  handleRowDbleClick(user) {
    const { me, handleStartLoading } = this.props;
    if (user && _toNumber(user.id) !== _toNumber(me.id)) {
      // Display loader and display user
      handleStartLoading();
      _delay(() => navigateToShow(user.id), 500);
    }
  }

  // Private
  doGetRowComp(props) {
    return (
      <UserRow
        {...props}
        onDelete={this.handleDeleteUser}
      />
    );
  }

  render() {
    const { users, handleGetUsersList } = this.props;

    return (
      <MainListTemplate
        title={
          <LocalizedMessage id="title.usersList" />
        }
        icon={mUser.icon}
        displayRefresh
        actionButtons={[
          <AddTextButton key="add" primary path={addPath()} />,
        ]}
        name={mUser.name}
        listFeatures={mUser.listFeatures}
        withActions
        nbActions={2}
        elementsData={{
          loading: users.loading,
          elements: users.elements,
          handleGetList: handleGetUsersList,
        }}
        onRowDbleClick={this.handleRowDbleClick}
        filtersComp={
          <UserFilters />
        }
        rowComp={this.doGetRowComp}
      />
    );
  }
}

UsersList.propTypes = {
  me: meDataShape.isRequired,
  users: fullListShape.isRequired,
  deleted: PropTypes.bool.isRequired,
  handleRefreshList: PropTypes.func.isRequired,
  handleDisplayConfirm: PropTypes.func.isRequired,
  handleGetUsersList: PropTypes.func.isRequired,
  handleDeleteUser: PropTypes.func.isRequired,
  handleStartLoading: PropTypes.func.isRequired,
  hasPermission: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  me: state.me.data,
  users: state.user.list,
  deleted: state.user.delete.deleted,
});

const mapDispatchToProps = (dispatch) => ({
  handleRefreshList: () => {
    dispatch(refreshList());
  },
  handleGetUsersList: (pagination, sort, filters) => {
    dispatch(getUsersList(pagination, sort, filters));
  },
  handleDeleteUser: (id) => {
    dispatch(deleteUser(id));
  },
});

module.exports = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withConfirmDialog,
  withLoading,
  withPermissions,
  withTitle('pageTitle.users'),
)(UsersList);



// WEBPACK FOOTER //
// ./routes/app/routes/users/routes/list/components/UsersList.js